import { View } from "react-native-web";
import { CImage } from "../../../components/atoms";
import { Constants, Images } from "../../../config";

export const venueFilterCriteria = (isMobileVersion, styles) => {
  return [
    {
      title: "Location",
      isHide: isMobileVersion,
      isLocation: true,
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_STATUS,
      icon: Images.iconTagStatus,
      width: 20,
      height: 20,
      title: "Status",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Open",
          tagId: 1,
        },
        {
          id: 2,
          label: "Closed",
          tagId: 2,
        },
        {
          id: 3,
          label: "Temporarily Closed",
          tagId: 4,
        },
        {
          id: 4,
          label: "Permanently Closed",
          tagId: 3,
        },
      ],
      selectedList: [1, 2, 4],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_VENUE,
      icon: Images.iconTagTagVenue,
      width: 20,
      height: 20,
      title: "Venue",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Club",
          tagId: 701,
        },
        {
          id: 2,
          label: "Bar",
          tagId: 702,
        },
        {
          id: 3,
          label: "Hall",
          tagId: 703,
        },
        {
          id: 4,
          label: "Stadium",
          tagId: 704,
        },
        {
          id: 5,
          label: "Open Air",
          tagId: 705,
        },
        {
          id: 6,
          label: "Other",
          tagId: 706,
        },
        {
          id: null,
          label: null,
          isSeparator: true,
        },
        {
          id: 7,
          label: "Indoor & Outdoor",
          tagId: 801,
        },
        {
          id: 8,
          label: "Indoor Only",
          tagId: 802,
        },
        {
          id: 9,
          label: "Outdoor Only",
          tagId: 803,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_FEATURES,
      icon: Images.iconTagLightning,
      width: 20,
      height: 20,
      title: "Features",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Upscale",
          tagId: 601,
        },
        {
          id: 2,
          label: "Elegant",
          tagId: 602,
        },
        {
          id: 3,
          label: "Underground",
          tagId: 603,
        },
        {
          id: 4,
          label: "Casual",
          tagId: 604,
        },
        {
          id: 5,
          label: "Alternative",
          tagId: 605,
        },
        {
          id: 6,
          label: "International",
          tagId: 606,
        },
        {
          id: 7,
          label: "Local",
          tagId: 607,
        },
        {
          id: 8,
          label: "Live Music",
          tagId: 608,
        },
        {
          id: 9,
          label: "Rooftop",
          tagId: 609,
        },
        {
          id: 10,
          label: "LGBT+",
          tagId: 610,
        },
        {
          id: 11,
          label: "Students",
          tagId: 611,
        },
        {
          id: 12,
          label: "Members",
          tagId: 612,
        },
        {
          id: 13,
          label: "Pool",
          tagId: 613,
        },
        {
          id: 14,
          label: "VIP",
          tagId: 614,
        },
        {
          id: 15,
          label: "Romantic",
          tagId: 616,
        },
        {
          id: 16,
          label: "Themed",
          tagId: 617,
        },
        {
          id: 17,
          label: "Pub",
          tagId: 618,
        },
        {
          id: 18,
          label: "Cocktail",
          tagId: 619,
        },
        {
          id: 19,
          label: "Swimming Pool",
          tagId: 620,
        },
        {
          id: 20,
          label: "Shisha",
          tagId: 621,
        },
        {
          id: 22,
          label: "Karaoke",
          tagId: 623,
        },
        {
          id: 23,
          label: "Live show",
          tagId: 624,
        },
        {
          id: 24,
          label: "Sex-positive",
          tagId: 625,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_MUSIC,
      icon: Images.iconTagMusic,
      width: 20,
      height: 20,
      title: "Music",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Electronic",
          tagId: 301,
        },
        {
          id: 2,
          label: "Pop",
          tagId: 302,
        },
        {
          id: 3,
          label: "Rock",
          tagId: 303,
        },
        {
          id: 4,
          label: "Hip-Hop",
          tagId: 304,
        },
        {
          id: 5,
          label: "R&B",
          tagId: 305,
        },
        {
          id: 6,
          label: "Reggae",
          tagId: 306,
        },
        {
          id: 7,
          label: "Jazz",
          tagId: 307,
        },
        {
          id: 8,
          label: "Blues",
          tagId: 308,
        },
        {
          id: 9,
          label: "Metal",
          tagId: 309,
        },
        {
          id: 10,
          label: "Punk",
          tagId: 310,
        },
        {
          id: 11,
          label: "Country",
          tagId: 311,
        },
        {
          id: 12,
          label: "Folk",
          tagId: 312,
        },
        {
          id: 13,
          label: "Latin",
          tagId: 313,
        },
        {
          id: 14,
          label: "Classical",
          tagId: 314,
        },
        {
          id: 15,
          label: "Religious",
          tagId: 315,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_PRICE_VENUE,
      icon: Images.iconTagPrice,
      width: 20,
      height: 20,
      title: "Price",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "1",
          tagId: 1501,
          prefixIcon: (
            <View style={styles.row}>
              <View style={{ marginRight: isMobileVersion ? 6 : 15 }}>
                <CImage
                  source={Images.iconTagPrice}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
              <View style={{ marginRight: isMobileVersion ? 6 : 15 }}>
                <CImage
                  source={Images.iconTagPriceGray}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
              <View style={{ marginRight: isMobileVersion ? 6 : 15 }}>
                <CImage
                  source={Images.iconTagPriceGray}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
              <View style={{ marginRight: isMobileVersion ? 0 : 3 }}>
                <CImage
                  source={Images.iconTagPriceGray}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
            </View>
          ),
        },
        {
          id: 2,
          label: "2",
          tagId: 1502,
          prefixIcon: (
            <View style={styles.row}>
              <View style={{ marginRight: isMobileVersion ? 6 : 15 }}>
                <CImage
                  source={Images.iconTagPrice}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
              <View style={{ marginRight: isMobileVersion ? 6 : 15 }}>
                <CImage
                  source={Images.iconTagPrice}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
              <View style={{ marginRight: isMobileVersion ? 6 : 15 }}>
                <CImage
                  source={Images.iconTagPriceGray}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
              <View style={{ marginRight: isMobileVersion ? 0 : 3 }}>
                <CImage
                  source={Images.iconTagPriceGray}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
            </View>
          ),
        },
        {
          id: 3,
          label: "3",
          tagId: 1503,
          prefixIcon: (
            <View style={styles.row}>
              <View style={{ marginRight: isMobileVersion ? 6 : 15 }}>
                <CImage
                  source={Images.iconTagPrice}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
              <View style={{ marginRight: isMobileVersion ? 6 : 15 }}>
                <CImage
                  source={Images.iconTagPrice}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
              <View style={{ marginRight: isMobileVersion ? 6 : 15 }}>
                <CImage
                  source={Images.iconTagPrice}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
              <View style={{ marginRight: isMobileVersion ? 0 : 3 }}>
                <CImage
                  source={Images.iconTagPriceGray}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
            </View>
          ),
        },
        {
          id: 4,
          label: "4",
          tagId: 1504,
          prefixIcon: (
            <View style={styles.row}>
              <View style={{ marginRight: isMobileVersion ? 6 : 15 }}>
                <CImage
                  source={Images.iconTagPrice}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
              <View style={{ marginRight: isMobileVersion ? 6 : 15 }}>
                <CImage
                  source={Images.iconTagPrice}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
              <View style={{ marginRight: isMobileVersion ? 6 : 15 }}>
                <CImage
                  source={Images.iconTagPrice}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
              <View style={{ marginRight: isMobileVersion ? 0 : 3 }}>
                <CImage
                  source={Images.iconTagPrice}
                  width={isMobileVersion ? 16 : 24}
                  height={isMobileVersion ? 16 : 24}
                  layout="fixed"
                />
              </View>
            </View>
          ),
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_RATING,
      icon: Images.iconTagRating,
      width: 21.5,
      height: isMobileVersion ? 21 : 20,
      title: "Rating",
      isHide: true,
      isRating: true,
      detailList: [
        {
          id: 1,
          label: "1",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating1}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 2,
          label: "2",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating2}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 3,
          label: "3",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating3}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 4,
          label: "4",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating4}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 5,
          label: "5",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating5}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_SERVICE,
      icon: Images.iconTagService,
      width: 20,
      height: 20,
      title: "Service",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Club",
          tagId: 1601,
        },
        {
          id: 2,
          label: "Bar",
          tagId: 1602,
        },
        {
          id: 3,
          label: "Restaurant",
          tagId: 1603,
        },
        {
          id: 4,
          label: "None",
          tagId: 1605,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_SIZE,
      icon: Images.iconTagSize,
      width: 20,
      height: 20,
      title: "Size",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "XXS",
          suffix: "0 - 200",
          tagId: 501,
        },
        {
          id: 2,
          label: "XS",
          suffix: "200 - 500",
          tagId: 502,
        },
        {
          id: 3,
          label: "S",
          suffix: "500 - 2K",
          tagId: 503,
        },
        {
          id: 4,
          label: "M",
          suffix: "2K - 5K",
          tagId: 504,
        },
        {
          id: 5,
          label: "L",
          suffix: "5K - 20K",
          tagId: 505,
        },
        {
          id: 6,
          label: "XL",
          suffix: "20K - 50K",
          tagId: 506,
        },
        {
          id: 7,
          label: "XXL",
          suffix: "50K+",
          tagId: 507,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_AREA,
      icon: Images.iconTagArea,
      width: 20,
      height: 20,
      title: "Area",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "City",
          tagId: 901,
        },
        {
          id: 2,
          label: "Town",
          tagId: 902,
        },
        {
          id: 3,
          label: "Countryside",
          tagId: 903,
        },
        {
          id: 4,
          label: "Field",
          tagId: 904,
        },
        {
          id: 5,
          label: "Forest",
          tagId: 905,
        },
        {
          id: 6,
          label: "Lake",
          tagId: 906,
        },
        {
          id: 7,
          label: "Beach",
          tagId: 907,
        },
        {
          id: 8,
          label: "Mountain",
          tagId: 908,
        },
        {
          id: 9,
          label: "Park",
          tagId: 909,
        },
        {
          id: 10,
          label: "Resort",
          tagId: 910,
        },
        {
          id: 11,
          label: "Unique Location",
          tagId: 911,
        },
        {
          id: 12,
          label: "Ship",
          tagId: 912,
        },
        {
          id: 13,
          label: "Other",
          tagId: 913,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_AGE,
      icon: Images.iconTagAge,
      width: 20,
      height: 20,
      title: "Age",
      isHide: false,
      isAge: true,
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_DRESS_CODE,
      icon: Images.iconTagDressCode,
      width: 20,
      height: 20,
      title: "Dress Code",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Casual",
          tagId: 1001,
        },
        {
          id: 2,
          label: "Smart",
          tagId: 1002,
        },
        {
          id: 3,
          label: "Elegant",
          tagId: 1003,
        },
      ],
      selectedList: [],
    },
  ];
};
